export default function getInitialLetters(string = "") {
  let initialLetters = [];
  string
    .split(" ")
    .map((word) => initialLetters.push(word[0]))
    .join("")
    .toUpperCase();
  return initialLetters;
}
